import { Divider, Link, Stack, Typography } from "@mui/material"

const Legales = () => (
    <Stack>
        <Divider
            sx={{
                mt: 2.5,
                typography: 'overline',
                color: 'text.disabled',
                '&::before, ::after': {
                    borderTopStyle: 'dashed',
                },
            }}
        />
        <Stack direction="row" mt={2} justifyContent="center">
            <Link target="_blank" href="/aviso_de_privacidad">
                <Typography 
                    variant="body2" 
                    color="text.disabled"
                    sx={{ textDecoration : 'underline' }}
                >
                    Términos y condiciones y aviso de privacidad
                </Typography>
            </Link>
        </Stack>
    </Stack>
)

export { Legales }
